import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { DateTime } from 'luxon';
import { makeStyles } from "../../../styles/index";
import { useTranslation } from "../../../hooks/useTranslation";
import { Button } from "../../Button/Button";
import { Divider } from "../../Divider/Divider";
import { Grid } from "../../Grid/Grid";
import { MenuItem } from "../../Menu/MenuItem";
import { MenuList } from "../../Menu/MenuList";
import { Popup } from "../../Popup/Popup";
import { PopupContainer } from "../../Popup/PopupContainer";
import { TextField } from "../../TextField/TextField";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
    },
    date: {
        flex: '1 0 0',
        minWidth: 0,
    },
    listContainer: {
        width: 152,
    },
    listScroll: {
        flex: 1,
        overflowY: 'scroll',
    },
    list: {
        maxHeight: 300,
    },
    listItem: {
        justifyContent: 'center',
    },
    actions: {
        padding: theme.spacing(1),
    },
    actionButton: {
        padding: 0,
        minWidth: 0,
        width: 64,
    },
}); }, { name: 'SnTimePickerField' });
var HOURS = Array.from(new Array(24)).map(function (v, i) { return ({
    id: "hour-" + i,
    value: i,
    display: i.toString().padStart(2, '0'),
}); });
var MINUTES = Array.from(new Array(60)).map(function (v, i) { return ({
    id: "minute-" + i,
    value: i,
    display: i.toString().padStart(2, '0'),
}); });
/**
 * 時刻選択フィールド。
 */
export var TimePickerField = function (props) {
    var _a;
    var className = props.className, style = props.style, value = props.value, onChange = props.onChange, _b = props.clearable, clearable = _b === void 0 ? true : _b;
    // ポップアップ開閉
    var _c = useState(null), anchorRef = _c[0], setAnchorRef = _c[1];
    var _d = useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var handleOpen = useCallback(function () { return setIsOpen(true); }, []);
    var handleClose = useCallback(function () { return setIsOpen(false); }, []);
    // コールバック
    var handleHourChange = function (hour) { return function () {
        var nextValue = value == null ? DateTime.local().set({ hour: hour }).startOf('hour') : value.set({ hour: hour });
        onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
    }; };
    var handleMinuteChange = function (minute) { return function () {
        var nextValue = value == null ? DateTime.local().set({ minute: minute }).startOf('minute') : value.set({ minute: minute });
        onChange === null || onChange === void 0 ? void 0 : onChange(nextValue);
    }; };
    var handleClear = useCallback(function () {
        onChange === null || onChange === void 0 ? void 0 : onChange(null);
        setIsOpen(false);
    }, [onChange]);
    var t = useTranslation().t;
    var classes = useStyles(props);
    return (React.createElement(PopupContainer, { className: classNames(classes.root, className), style: style },
        React.createElement("div", { className: classes.date, ref: setAnchorRef },
            React.createElement(TextField, { readonly: true, dense: true, placeholder: t('時刻'), value: (_a = value === null || value === void 0 ? void 0 : value.toFormat(t('HH:mm'))) !== null && _a !== void 0 ? _a : '', onClick: handleOpen })),
        React.createElement(Popup, { open: isOpen, anchorEl: anchorRef, onClickAway: handleClose, portal: true, boundariesElement: "viewport" },
            React.createElement(Grid, { container: true, className: classes.listContainer },
                React.createElement(Grid, { item: true, className: classes.listScroll },
                    React.createElement(MenuList, { autoFocusItem: isOpen, className: classes.list, onCancel: handleClose, onPrev: handleClose }, HOURS.map(function (hour) { return (React.createElement(MenuItem, { key: hour.id, className: classes.listItem, onClick: handleHourChange(hour.value), selected: (value === null || value === void 0 ? void 0 : value.hour) === hour.value }, hour.display)); }))),
                React.createElement(Grid, { item: true, className: classes.listScroll },
                    React.createElement(MenuList, { className: classes.list, onCancel: handleClose, onNext: handleClose }, MINUTES.map(function (minute) { return (React.createElement(MenuItem, { key: minute.id, className: classes.listItem, onClick: handleMinuteChange(minute.value), selected: (value === null || value === void 0 ? void 0 : value.minute) === minute.value }, minute.display)); })))),
            clearable && (React.createElement(React.Fragment, null,
                React.createElement(Divider, { thin: true }),
                React.createElement(Grid, { container: true, className: classes.actions, alignItems: "center", justify: "space-between" },
                    React.createElement(Button, { variant: "text", className: classes.actionButton, onClick: handleClear }, "\u30AF\u30EA\u30A2"),
                    React.createElement(Button, { variant: "square", fill: true, className: classes.actionButton, onClick: handleClose }, "OK")))))));
};
